import { __rest } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { asStyledComponent } from '@clds/component-enhancer';
import { globalTheme } from '@clds/component-theme';
import { Label } from '../Label.js';
const Wrapper = styled.div `
  display: flex;
  align-items: center;

  ${Label} {
    margin: 0;
    margin-left: ${globalTheme.spacing.xs};
  }
`;
/**
 * InlineFieldLayout is component that positions properly common form field elements - label and input control.
 * This is layout component only. In order to build a form field you need to place <em>Label</em> inside label region,
 * any input control as a child.
 */
export const InlineFieldLayout = asStyledComponent((_a) => {
    var { label, children } = _a, rest = __rest(_a, ["label", "children"]);
    return (React.createElement(Wrapper, Object.assign({}, rest),
        children,
        label));
});
//# sourceMappingURL=InlineFieldLayout.js.map